import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';

import 'semantic-ui-css/semantic.min.css';
import './index.scss';

import App from './App';
// import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(
	<BrowserRouter basename={"/"+window.options.base_url}>
		<App/>
	</BrowserRouter>,
	document.getElementById('root')
);

// registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js